var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{attrs:{"href":"#"}},[_c('b-container',{staticClass:"p-0 m-0",attrs:{"width":"100px"}},[_c('b-img',{attrs:{"src":require('@/assets/img/logo_white_mini.png'),"width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }